import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ConsignmentsPage from './pages/ConsignmentsPage';
import ConsignmentPage from './pages/ConsignmentPage';
import ConsignmentSettingsPage from './ConsignmentSettingsPage';
import ConsignmentRoutes from './ConsignmentRoutes';

const manifest = {
  id: 'consignment',
  nameKey: 'extensions.consignment.name',
  descriptionKey: 'extensions.consignment.description',
  icon: HandshakeOutlinedIcon,
  route: '/consignments',
  menuItem: {
    labelKey: 'consignment.menu',
    basePath: '/consignments',
    children: [
      { labelKey: 'consignment.menu_list', path: '/consignments', end: true },
      { labelKey: 'consignment.menu_settings', path: '/consignments/settings' },
    ],
  },
  nestedRoutes: {
    Layout: ConsignmentRoutes,
    routes: [
      { index: true, Component: ConsignmentsPage, titleKey: 'consignment.menu_list' },
      { path: 'new', Component: ConsignmentPage, titleKey: 'consignment.new_consignment' },
      { path: 'settings', Component: ConsignmentSettingsPage, titleKey: 'consignment.settings_title' },
      { path: ':id', Component: ConsignmentPage, titleKey: 'consignment.detail_title' },
    ],
  },
  requiredExtensions: [],
  Page: ConsignmentsPage,
};

export default manifest;
